import { toast } from 'react-toastify';

const dismissToast = toastId => {
  return toast.dismiss(toastId.current || toastId);
};

export default dismissToast;
